import { IState } from './state';
import { ActionTree } from 'vuex';
import { IStore } from "@store/index";
import { fetchDateAndPriceData, updateAppointment } from "@store/services/fetchCheckoutData";
import { AxiosResponse } from "axios";
import { EVENT_FETCH_PRICES, EVENT_PRICES_FETCHED } from "@constants/event";
import { UpdateAppointmentStatus } from "@store/dateAndPrice/interfaces/updatedAppointment";
import { isValidLocale } from "@constants/locale";

export default {
    async getDateAndPrice({ state, commit, dispatch }, { endpoint, tripId, filter, token, locale }) {
        try {
            if (tripId !== 0 && isValidLocale(locale)) {
                const response: AxiosResponse = await fetchDateAndPriceData(endpoint, tripId, filter, token, locale);

                commit('setCurrentFilter', filter);
                commit('setDateAndPriceData', response.data);
                commit('extractCalendarData');
                commit('setFetchingStatus');
            }
        } catch (e: any) {
            const errorStatus = e.response ? e.response.status : 'none';
            const message = `Error in getDateAndPrice | Error code: 1621762972 | HTTP status: ${errorStatus} | ${e.message}`;

            commit('setFetchingStatus');

            if (state.isInCheckout) {
                dispatch('checkout/openErrorOverlay', null, { root: true });
            }

            throw Error(message);
        }
    },
    async updateAppointment({ commit, dispatch, state }, { endpoint, tripId, appointmentId, token, fare, price, departureAirport, locale }) {
        try {
            if (tripId !== 0 && appointmentId !== '') {
                if (!state.isInCheckout) {
                    dispatch('funnel/pushEventDataLayer', {
                        eventName: EVENT_FETCH_PRICES,
                        price: price,
                        appointment: appointmentId
                    }, { root: true });
                }

                commit('enableLoading');
                await updateAppointment(endpoint, 'UpdateAppointment', tripId, appointmentId, token, fare, locale)
                    .then((response) => {
                        commit('setUpdatedData', { ...response.data, appointmentId, departureAirport });
                        commit('disableLoading');

                        if (response.data.status === UpdateAppointmentStatus.SUCCESS) {
                            commit('checkout/setSessionId', response.data.sessionId, { root: true });
                        }

                        if (!state.isInCheckout) {
                            dispatch('funnel/pushEventDataLayer', {
                                eventName: EVENT_PRICES_FETCHED,
                                extraData: {
                                    price_before: price,
                                    price_after: state.updatedAppointment?.price ?? null
                                },
                                price: price,
                                appointment: appointmentId
                            }, { root: true });
                        }
                    });
            }
        } catch (e: any) {
            const responseStatus = e.response ? e.response.status : 'none';
            const message = `Error in updateAppointment | Error code: 1621762972 | HTTP status: ${responseStatus} | ${e.message}`;

            dispatch('checkout/openErrorOverlay', null, { root: true });

            throw Error(message);
        }
    },
} as ActionTree<IState, IStore>
